/**
  * @class meleActorDopplerBeam
  * @description
  *
  * # Purpose
  * Implements `<mele-actor-dopplerbeam>` custom web element for showing doppler radar vehicle in beam
  */

import meleActor from 'meleActor'
const Algo = require('../../msys/msysAV/src_em/algo.js')
const Draw = require('../../msys/msysAV/src_em/draw.js')
const DopplerDraw = require('../../msys/msysAV/src_em/doppler_draw.js')

const PROPERTIES = _.extend({}, {
  ets: { description: 'event timestamp - current playback time in miliseconds', type: 'integer' },
}, meleActor._properties)

export default class meleActorDopplerBeam extends meleActor {
  init() {
    this.canvas = this.appendChildren({ tag: 'canvas' })
    this.canvas.width = 0
    this.canvas.height = 0
    this.beams = []
    super.init()
  } // init

  message({ action, params }) {
    if(params.channel===parseInt(this.parentElement.ch)) {
      if(action==='mmDopplerMeta') this.mmDopplerMeta(params)
      else if(action==='mmDopplerBeam') this.mmDopplerBeam(params)
    }
  } // message

  mmDopplerMeta(meta) {
    this.rig = Algo.rig(meta?.calibration, meta?.optics)
    if(meta.state!=='on') {
      Draw.clear(this.canvas)
    }
  } // mmDopplerMeta

  mmDopplerBeam(params) {
    this.beams.push(params)
    this.beams = this.beams.sort((a, b)=>b.event_dt-a.event_dt)
  } // mmDopplerBeam

  drawBeam(beam) {
    const { channel, event } = beam

    const [ctx] = Draw.getContext(this.canvas, true)

    if(this.rig?.channel!==channel) {
      Draw.clear(this.canvas)
      return
    }

    const { h_pixels, v_pixels } = this.rig
    if(this.canvas.width !== h_pixels) this.canvas.width = h_pixels
    if(this.canvas.height !== v_pixels) this.canvas.height = v_pixels
    Draw.clear(ctx)

    const { lateral, speed } = event
    if(isNaN(lateral) || isNaN(speed)) {
      return
    }

    DopplerDraw.drawTravelLine(ctx, this.rig, lateral)
    DopplerDraw.drawBeamGroundUp(ctx, this.rig, lateral)
  } // drawBeam

  async play() {
    this.beams = []
    Draw.clear(this.canvas)
  } // play

  async etsChanged(ets) {
    const keep = 50_000
    const befores = this.beams.filter(b=>b.event_dt < ets && ets-b.event_dt < keep)
    const afters = this.beams.filter(b=>b.event_dt >= ets)
    let before = befores.pop()
    const after = afters[0]
    let closest
    if(!before && !after) {
      Draw.clear(this.canvas)
      return
    }
    if(before && after) {
      if(Math.abs(before.event_dt-ets) < Math.abs(after.event_dt-ets)) {
        closest = before
      }else {
        closest = after
        before = null // to prevent keeping 'before beam' as 'after beam' is already closer to play time
      }
    }else {
      closest = before || after
    }

    // adjust beams stack to contain only beams that ar in future
    // and the closest beam before withing keep time
    this.beams = afters
    if(before) this.beams.unshift(before)

    // this will happen when there are some beams but too far in the future
    const diff_us = Math.abs(closest.event_dt-ets)
    if(diff_us > keep) {
      Draw.clear(this.canvas)
      return
    }

    this.drawBeam(closest)
  } // etsChanged
} // class meleActorDopplerBeam

meleActorDopplerBeam._properties = PROPERTIES
meleActorDopplerBeam.observedAttributes = _.keys(PROPERTIES)
window.customElements.define('mele-actor-dopplerbeam', meleActorDopplerBeam)
